module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/plan2-3-ce5a8b3fcace821a1323f3333146411d.webp";